<!--
 * @Descripttion:
 * @version:
 * @Author: Jeson
 * @Date: 2021-09-16 14:53:53
 * @LastEditors: Jerry
 * @LastEditTime: 2022-02-17 15:40:40
-->
<template>
  <div class="Content_Div">
    <div
      class="Gift_Div"
      :style="{background:Background?Background:'#f1f7fe'}"
    >
      <div
        v-for="(item,index) in GiftList"
        :key="index"
        class="Gift_Div_List"
      >
        <div class="Gift_Div_Item">
          <div class="Gift_Div_Title">
            <div class="Gift_Div_Title_Label">赠品{{ index+1 }}</div>
            <div class="Gift_Div_Title_Img"><img :src="item.Type==3?require('../../../assets/coupon.png'):item.Logo"></div>
          </div>
          <div class="Gift_Div_Content">

            <div class="tags_box">
              <!-- 医保标签标签 -->
              <div
                v-for="properties in item.CommodityListProperties"
                v-if="properties.AttributeName == '医保类型'"
                :key="properties.Id"
                style="margin-right: 4px; font-size: 0;"
              >
                <img
                  v-if="properties.Value == 1"
                  src="@/assets/goods/class_a.png"
                  width="28px"
                  height="16px"
                >
                <img
                  v-if="properties.Value == 2"
                  src="@/assets/goods/class_b.png"
                  width="28px"
                  height="16px"
                >
                <img
                  v-if="properties.Value == 3"
                  src="@/assets/goods/yibao.png"
                  width="28px"
                  height="16px"
                >
              </div>
              <!-- 商品标签 -->
              <img
                v-if="item.GoodsTags && item.GoodsTags.length"
                :src="item.GoodsTags[0].Img"
                style="width: 32px; height: 16px;"
              >
              <div class="Gift_Div_Content_Name">
                {{ item.Type!=3?item.Name:'优惠券' }}
              </div>
            </div>

            <div
              v-if="item.Type!=3"
              class="Gift_Div_Content_Spc"
            >规格：{{ item.Specifications }}/{{ item.Unit }}</div>
            <div
              v-if="item.Type==3"
              class="Gift_Div_Content_Counp"
            >
              满{{ item.GoodsLimitPrice }}元{{ item.DeductionMode==1?'减':'打' }}{{ item.DeductionLimit }}{{ item.DeductionMode==1?'元':'折' }}
            </div>
            <div class="Gift_Div_Content_Amount">赠送数量：{{ item.Amount }} <label
              v-if="Multiple>1"
              class="number"
            >x {{ Multiple }}</label><span
              v-show="item.IsOutBusinessScope"
              class="Gift_Div_Content_Spc"
            >超出经营范围无法赠送</span>

              <span
                v-show="item.IsOutControl"
                class="Gift_Div_Content_Spc"
              >已被他人控销无法赠送</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="Show&&isNotClick"
      class="Gift_Btn"
      @click.stop="choseGift()"
    >
      <span>选择赠品</span>
    </div>
  </div>

</template>

<script>
export default {
  name: 'BuyCarGiftItem',
  props: {
    GiftList: {
      type: Array,
      default: () => []
    },
    isNotClick: {
      type: Boolean,
      default: true
    },
    Background: {
      type: String,
      default: ''
    },
    Multiple: {
      type: Number,
      default: null
    },
    ChooseGiftNum: {
      type: Number,
      default: null
    },
    ActivityId: {
      type: String,
      default: ''
    },
    isByOrder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      Show: true
    }
  },
  watch: {
    GiftList: {
      handler(v) {
        let totolNum = 0

        if (v) {
          v.map(oo => {
            if (oo.IsMustSend) {
              totolNum++
            }
          })
          if (totolNum == v.length) {
            this.Show = false
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() { },
  created() { },
  methods: {
    // 选择赠品
    choseGift() {
      this.$emit('choseGift', {
        GiftList: this.GiftList, Multiple: this.Multiple, ChooseGiftNum: this
          .ChooseGiftNum, ActivityId: this.ActivityId, isByOrder: this.isByOrder
      })
    }
  }
}
</script>

<style lang='less' scoped>
@import url("./src/styles/BuyCarGiftItem.less");
</style>
